import unidecode from 'unidecode';

export function slugify(str: string): string {
  const separator = '-';
  str = unidecode(str);

  str = str
    .replace(/[:\/\?#\[\]@!$&'()*+,;=\\%<>\|\^~£"]/g, '')
    // Replace dots and spaces with a sepeator
    .replace(/(\s|\.)/g, separator)
    // Convert 2 or more sepeators into just one sepeator
    .replace(/-+/g, separator)
    // Make the whole thing lowercase
    .toLowerCase();

  if (str.substring(str.length - 1) === '-') {
    str = str.substring(0, str.length - 1);
  }

  return str;
}
